/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import LoadPanel from "devextreme-react/load-panel";
import { formatMessage } from "devextreme/localization";
import { IsPermisionOidRequired } from "../../../redux/actions";
import { responseMiddleware } from "../../../redux/reducers";
import OvertimeRegistrationDataTableList from "./OvertimeRegistrationDataTable";
import "./style.scss";
import UsingIntl from "../../../services/using_intl";

export default function OvertimeRegistrationDataList() {
  const history = useHistory();
  const dispatch = useDispatch();
  let dataGrid = useRef(null);
  const { middleware, loading } = useSelector(responseMiddleware);

  useEffect(() => {
    dispatch(IsPermisionOidRequired());
    UsingIntl();
  }, [dispatch]);

  useEffect(() => {
    if (middleware) {
      const { ReadState, NavigateState } = middleware;
      if (
        (NavigateState !== undefined && !NavigateState) ||
        (ReadState !== undefined && !ReadState)
      ) {
        history.push("/403");
        return;
      }
    }
  }, [middleware]);
  return (
    <>
      <LoadPanel visible={loading} />
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>
            {formatMessage("OvertimeRegistrationData")}
          </div>
        </div>
        <div className={"breadcrumb-right"}>
          <Link to="/overtime-registration/list" className={"breadcrumb-item"}>
            {formatMessage("Overtime")}
          </Link>
          <span className={"breadcrumb-item active"}>
            {formatMessage("OvertimeRegistrationData")}
          </span>
        </div>
      </div>
      <div className={"section"}>
        <div className={"section-body"}>
          <OvertimeRegistrationDataTableList
            dataGrid={dataGrid}
            middleware={middleware}
          />
        </div>
      </div>
    </>
  );
}
